import { RouteObject } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import ProtectedRoute from "./ProtectedRoute";
import { homeRoutes } from "../features/home";
import { verificationRoutes } from "../features/verification";

export const routeConfig: RouteObject[] = [
  {
    element: <ProtectedRoute />,
    children: [
      {
        path: "/",
        element: <MainLayout />,
        children: [...homeRoutes, ...verificationRoutes],
      },
    ],
  },
];
